(ns common.schema.entities.counterparty-diligence.person
  (:require
   [common.schema.entities.counterparty-diligence.common :as counterparty-diligence-common]
   [common.schema.entities.counterparty-diligence.templates.registry :as template-registry]
   [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]
   [common.schema.schema-utils :as su]))

(def template-options
  (->> template-registry/natural-person-templates
       (mapv (fn [[template-id template]]
               {:key template-id
                :value template-id
                :label (:template/template-name template)}))))

(def screening-status-options
  (->>
   [{:value :screening-status/active
     :label "Active"}
    {:value :screening-status/inactive
     :label "Inactive"}]
   (mapv (fn [{:keys [value] :as opt}]
           (assoc opt :key value)))))

(def screening-status-lookup
  (->> screening-status-options
       (mapv (fn [{:keys [value] :as opt}]
               [value opt]))
       (into {})))

(defn get-screening-status-label
  [screening-status]
  (get-in screening-status-lookup [screening-status :label]))

;; TODO
(def schema
  (concat
   (su/text-simple-field :person-counterparty-diligence/person-name
                         "Person name"
                         {:mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use-disabled})

   (su/keyword-field :person-counterparty-diligence/template
                     "Template"
                     template-options
                     {:mandatory-config         :mandatory/always
                      :system-required?         true
                      :system-semantics
                      su/user-provided-system-required-field-semantics
                      :default-field-visibility :in-use-disabled
                      :option-filter-fn         counterparty-diligence-util/template-option-filter})

   (su/keyword-field :person-counterparty-diligence/screening-status
                     "Screening status"
                     screening-status-options
                     {:default-field-visibility :in-use})

   counterparty-diligence-common/schema))
